import { FC, useEffect, useRef, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
interface IProps {
    type?: string;
}

const Banner: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.end.CelebratingUs');

    const [isEnterA, setisEnterA] = useState(false);
    const isEnterRefA = useRef(false);
    const [isEnterB, setisEnterB] = useState(false);
    const isEnterRefB = useRef(false);
    useEffect(() => {
        const elem = document.querySelector(`#teaser-CelebratingUs`);
        if (elem) {
            window.addEventListener('scroll', () => {
                const clientH = document.documentElement.clientHeight;
                const enterAH = window.innerWidth < 768 ? 500 : Math.min(300, clientH * 0.2);
                const { top } = elem.getBoundingClientRect();
                const hIsEnterA = top < enterAH; //距离已进入
                const hIsEnterB = top <= -500; //距离已进入

                if (!isEnterRefA.current && hIsEnterA) {
                    isEnterRefA.current = true;
                    setisEnterA(true);
                } else if (isEnterRefA.current && !hIsEnterA) {
                    isEnterRefA.current = false;
                    setisEnterA(false);
                }
                if (!isEnterRefB.current && hIsEnterB) {
                    isEnterRefB.current = true;
                    setisEnterB(true);
                } else if (isEnterRefB.current && !hIsEnterB) {
                    isEnterRefB.current = false;
                    setisEnterB(false);
                }
            });
        }
    }, []);

    return (
        <div className={`${styled.Banner}`} id="teaser-CelebratingUs">
            <div className={`CelebratingUs-sticky-in editor-ani-trigger sticky-in${isEnterA ? ' isEnterA' : ''}${isEnterB ? ' isEnterB' : ''}`}>
                <EditorImg
                    className="sticky-img"
                    pc="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711005658169/Celebratingjpg.jpg"
                    h5="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711005799225/Celebratingjpg.jpg"
                />
                <div className="after"></div>
                <div className="sticky-msg-box">
                    <div className="sticky-msg-line-a">
                        <div className="box-title editor-ani-title-a-1">{t('title')}</div>
                        <div className="box-desc editor-ani-title-a-2">
                            {t.rich('desc1', {
                                color2: (text: string) => <span className="box-color-3">{text}</span>,
                            })}
                        </div>
                    </div>
                    <div className="sticky-msg-line-b">
                        <div className="box-desc editor-ani-title-b-1">
                            {t.rich('desc2', {
                                color2: (text: string) => <span className="box-color-2">{text}</span>,
                            })}
                        </div>
                        <div className="box-desc editor-ani-title-b-2">
                            {t.rich('desc3', {
                                color2: (text: string) => <span className="box-color-2">{text}</span>,
                            })}
                        </div>
                        <div className="box-desc editor-ani-title-b-3">
                            {t.rich('desc4', {
                                color2: (text: string) => <span className="box-color-2">{text}</span>,
                            })}
                        </div>
                        <div className="box-desc box-color-3 editor-ani-title-b-4">{t('desc5')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
